import { ApiFactory, initBfApi } from '~library/services'
import { initAuthApi, initUnAuthApi } from './apis'
import axiosAuthInstance from './axios-auth-instance'
import axiosUnAuthInstance from './axios-un-auth-instance'

export type Api = typeof api

export const api = {
  ...initUnAuthApi(new ApiFactory(axiosUnAuthInstance)),
  ...initAuthApi(new ApiFactory(axiosAuthInstance)),
  ...initBfApi({
    authApi: new ApiFactory(axiosAuthInstance),
    unAuthApi: new ApiFactory(axiosUnAuthInstance)
  })
}
